import { parseTemplate } from 'url-template';
import { formatApiDate } from '~/Api/DateTime';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import ErrorResponse from './ErrorResponse';
import mapSiMaxPrice from './mapSiMaxPrice';
import ProductUpdate from './ProductUpdate';
import SiMaxPrice from './SiMaxPrice';

export interface Result {
	siMaxPrice: SiMaxPrice;
}

export default function updateSiMaxPrice(
	client: ApiClient,
	userId: string,
	groupId: string,
	referenceBasketVersion: string,
	referencedProductType: string,
	packageSize: number | null,
	dosageStrength: number | null,
	historicProductDataViewDate: Date | null,
	products: ProductUpdate[]
): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/si-max-price');

	return client
		.fetch(url.expand({ userId, groupId }), {
			method: 'POST',
			body: JSON.stringify({
				reference: {
					referenceBasketVersion,
					referencedProductType,
					packageSize,
					dosageStrength,
					historicProductDataViewDate:
						historicProductDataViewDate !== null ? formatApiDate(historicProductDataViewDate) : null,
				},
				products: products.map((product) => ({
					id: product.id,
					priceTypeForCalculation: product.priceTypeForCalculation,
					packageSizeForCalculation: product.packageSizeForCalculation,
					packageSizeForSingleUnit: product.packageSizeForSingleUnit,
					dosageStrengthForCalculation: product.dosageStrengthForCalculation,
					selected: product.selected,
				})),
			}),
		})
		.then((response) => response.json())
		.then((response) => ({
			siMaxPrice: mapSiMaxPrice(response.siMaxPrice),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, ErrorResponse));
}
